import React, { useState, useEffect } from 'react';

import { Spin, Button, Row, Col, Typography } from 'antd';

import { ModalRazaoReprovacao } from './modalRazaoReprovacao';
import { ModalExclusaoRazao } from './modalExclusaoRazao';
import editGroupIcon from '../../../../../assets/icons/editGroup.svg';
import binGroup from '../../../../../assets/icons/binGroup.svg';
import colors from '../../../../../styles/colors';
import * as S from '../../styles';

export function GridRazoesReprovacao({
  razoesReprovacaoConsulta,
  form,
  idConsulta,
}) {
  const [razoesReprovacao, setRazoesReprovacao] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModalRazao, setOpenModalRazao] = useState(false);
  const [razaoEdit, setRazaoEdit] = useState(null);
  const [indexEdit, setIndexEdit] = useState(null);
  const [openModalExclusaoRazao, setOpenModalExclusaoRazao] = useState(false);
  const [razaoExclusao, setRazaoExclusao] = useState();

  const { Text } = Typography;

  const handleEdit = (razao, index) => {
    setIndexEdit(index);
    setRazaoEdit({ ...razaoEdit, ...razao }, () => {});
    setOpenModalRazao(true);
  };

  const removeRazao = index => {
    setRazaoExclusao(index);
    setOpenModalExclusaoRazao(true);
  };

  useEffect(() => {
    const razoesConsulta = razoesReprovacaoConsulta?.map(x => ({
      idRazaoReprovacao: x?.idRazaoReprovacao,
      idTipoReprovacao: x?.idTipoReprovacao,
      idConsulta,
      razao: x?.razao,
      descricao: x?.descricao,
    }));
    form.setFieldsValue({
      razoesForm: razoesConsulta,
    });
    setRazoesReprovacao(razoesConsulta ?? []);
  }, [razoesReprovacaoConsulta]);

  useEffect(() => {
    form.setFieldsValue({
      razoesForm: razoesReprovacao,
    });
  }, [razoesReprovacao]);

  return (
    <>
      <Row style={{ width: '100%', alignItems: 'center' }} span={24}>
        <Col span={20}>
          <Text
            style={{
              fontFamily: 'roboto',
              fontWeight: '700',
              color: colors.greyText,
            }}
          >
            Razoes de reprovação
          </Text>
        </Col>
        <Col span={4}>
          <Button
            type="text"
            style={{ color: colors.verde, background: colors.branco }}
            onClick={() => {
              setRazaoEdit(null);
              setOpenModalRazao(true);
            }}
          >
            + Adicionar razão
          </Button>
          <ModalRazaoReprovacao
            open={openModalRazao}
            setOpen={setOpenModalRazao}
            razoesReprovacao={razoesReprovacao}
            setRazoesReprovacao={setRazoesReprovacao}
            idConsulta={idConsulta}
            razaoEdit={razaoEdit}
            indexEdit={indexEdit}
          />
        </Col>
      </Row>
      <Spin
        spinning={loading}
        size="large"
        style={{
          width: '100%',
        }}
        tip="Carregando lista de Razões de Reprovação"
        delay={200}
      >
        {razoesReprovacao?.map((item, i) => (
          <S.RowsForColumn key={i}>
            <S.RowData
              style={{ color: '#828282', cursor: 'initial' }}
              key={item.id}
              justify="center"
              span={24}
            >
              <S.StyledColRow
                style={{ cursor: 'pointer', justifyContent: 'flex-start' }}
                onClick={() => handleEdit(item, i)}
                span={22}
              >
                {item?.razao || ''}
              </S.StyledColRow>
              <S.StyledColRow
                span={1}
                style={{ cursor: 'pointer' }}
                onClick={() => handleEdit(item, i)}
              >
                <img
                  src={editGroupIcon}
                  alt="edit"
                  onClick={() => handleEdit(item, i)}
                />
{' '}
              </S.StyledColRow>
              <S.StyledColRow span={1}>
                <img
                  style={{ cursor: 'pointer' }}
                  src={binGroup}
                  alt="bin"
                  onClick={() => removeRazao(i)}
                />
              </S.StyledColRow>
            </S.RowData>
          </S.RowsForColumn>
        ))}
        <ModalExclusaoRazao
          isModalVisible={openModalExclusaoRazao}
          setIsModalVisible={setOpenModalExclusaoRazao}
          indexRazao={razaoExclusao}
          setRazoesReprovacao={setRazoesReprovacao}
          razoesReprovacao={razoesReprovacao}
        />
      </Spin>
    </>
  );
}
